import { render, staticRenderFns } from "./index.vue?vue&type=template&id=676c04e4&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c04e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676c04e4')) {
      api.createRecord('676c04e4', component.options)
    } else {
      api.reload('676c04e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=676c04e4&scoped=true", function () {
      api.rerender('676c04e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/cdkey/index.vue"
export default component.exports